// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';
import { useRouter } from 'vue-router';
import store from '../../index.js';

const router = useRouter();

export default {
    async login({ commit, dispatch }, { email, password }) {
        try {
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/auth/login`, {
                email: email,
                password: password
            });
            console.log('Ответ сервера:', response.data);
            commit('SET_AUTHENTICATED', true);
            Cookies.set('access_token', response.data.access_token, { expires: 7 });
            commit('setAccessToken', response.data.access_token);
            dispatch('getUserByToken')
        } catch (error) {
            console.error('Произошла ошибка:', error);
            commit('SET_AUTHENTICATED', false);
        }
    },




    logout({ commit }) {
        Cookies.remove('access_token');
        commit('SET_AUTHENTICATED', false);
        commit('SET_USER', null);
        commit('setAccessToken', null);
        location.href = `/auth/login`;
    },

    async checkAuth({ commit, dispatch, state, rootState, rootGetters }, { id }) {

            const access_token = rootGetters.access_token;
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/auth/check`, config);
            
        } catch (error) {
            if(error.message === 'Request failed with status code 401') {
                Cookies.remove('access_token');
                commit('SET_AUTHENTICATED', false);
                commit('SET_USER', null);
                commit('setAccessToken', null);
                location.href = `/auth/login`;
            }
        }
                
            
    }
};
